import axios from "axios";
import { CompanySettingsCopyInterface } from "../../interfaces/CompanySettingsCopyInterface";

const { REACT_APP_AUTH_API } = process.env;

export const copyCompanySettings = async (
  company_id: string,
  settings: CompanySettingsCopyInterface,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "put",
      url: `${REACT_APP_AUTH_API}/companies/${company_id}/copy_settings`,
      headers: { Authorization: `Bearer ${token}` },
      data: settings,
    });
    return { data: response?.data?.data, errors: response?.data?.fails };
  } catch (e) {
    return { details: e?.response?.data?.msg };
  }
};
